import { yup } from "@swa-ui/object";

const PAYMENT_CARD_NUMBER_MAX_LENGTH = 19;
const PAYMENT_CARD_NUMBER_MIN_LENGTH = 13;
const CARD_NUMBER_KEY_PATTERN = /^cardNumber\d+$/;
const CARD_NUMBER_PATTERN = new RegExp(
  `^\\d{${PAYMENT_CARD_NUMBER_MIN_LENGTH},${PAYMENT_CARD_NUMBER_MAX_LENGTH}}$`
);

const creditCardNumbersSchema = yup
  .object()
  .test("at-least-one-card", (value) => value && Object.keys(value).length > 0)
  .test(
    "valid-card-number-keys",
    (value) => value && Object.keys(value).every((key) => CARD_NUMBER_KEY_PATTERN.test(key))
  )
  .test(
    "valid-card-number-values",
    (value) =>
      value &&
      Object.values(value).every(
        (cardNumber) =>
          typeof cardNumber === "string" && CARD_NUMBER_PATTERN.test(cardNumber.replace(/\s+/g, ""))
      )
  );

export const getPaymentCardEncryptionSchema = () =>
  yup.object().shape({
    creditCardNumbers: creditCardNumbersSchema.required("Credit card numbers are required"),
  });
